import { Avatar, Tooltip } from 'antd';

import type { AirlineBest } from '../lib/flights.ts';
import { fmtMoney } from '../lib/format.ts';

interface Props {
  airlines: AirlineBest[];
}

/** One chip per airline showing its cheapest fare in the month. */
export function AirlineStrip({ airlines }: Props) {
  if (!airlines.length) return null;
  return (
    <div className="airline-strip">
      {airlines.map((f) => (
        <Tooltip key={`${f.airlineCode ?? f.airline}`} title={`Cheapest on ${f.date}`}>
          <div className="airline-chip">
            <Avatar size="small" src={f.airlineLogo ?? undefined}>
              {(f.airlineCode ?? f.airline ?? '?').slice(0, 2)}
            </Avatar>
            <span className="airline-chip__name">{f.airline || 'Unknown'}</span>
            <span className="airline-chip__price">
              {fmtMoney(f.price)} <small>{f.currency}</small>
            </span>
          </div>
        </Tooltip>
      ))}
    </div>
  );
}
